module.exports = __webpack_public_path__ + "img/ico_credit.7aa030f5.png";